import React, { HTMLAttributes } from "react";
import clsx from "clsx";

interface CarouselItemProps extends HTMLAttributes<HTMLDivElement> {
  isActive: boolean;
  bannerCarousel?: boolean;
}

const CarouselItem = ({ isActive,bannerCarousel, className, children }: CarouselItemProps) => {
  return (
    <div
      aria-live={bannerCarousel ? "off" : undefined}
      className={clsx(
        "carousel-item relative float-left w-full ",
        {
          active: isActive,
        },
        className
      )}
    >
      {children}
    </div>
  );
};

export default CarouselItem;
